export enum ProductType {
  COOKING_APPLIANCE = 'Cooking Appliance',
  CORNER_RADIUS = 'RADIUS',
  COUNTERTOP = 'E',
  CUSTOM_WORK = 'Custom Work',
  CUTOUT = 'OPTION',
  DIAGONAL = 'Diagonal',
  DISHWASHER = 'Dishwasher',
  EDGE = 'EDGE',
  FAUCET = 'Faucet',
  JOINT_POINT = 'JOINT_POINT',
  LABOR = 'LABOR',
  OTHER = 'Other',
  OVERSIZE_FEE = 'Oversize Fee',
  REFRIGERATOR = 'Refrigerator',
  SINK = 'Sink',
  SINK_LABOR = 'SINK LABOR',
  TEAR_OUT = 'Tear-out',
  WARRANTY = 'Warranty',
  INSIDE_DIAGONAL = 'Inside-Diagonal',
  ELECTRICAL_CUTOUT = 'Electrical Cutout',
  FAUCET_CUTOUT = 'Faucet Cutout',
  CHIP_MINIMIZER = 'Chip Minimizer',
  OPTIONAL_PRODUCT = 'Optional Product',
  MODIFY_ON = 'Add On',
  MILEAGE_TIER = 'Mileage Tier',
  PLUMBING = 'Plumbing',
  END_CAP = 'End Cap',
  END_SPLASH = 'End Splash',
}

export const productTypeSortOrder = [
  ProductType.COUNTERTOP,
  ProductType.EDGE,
  ProductType.END_CAP,
  ProductType.END_SPLASH,
  ProductType.WARRANTY,
  ProductType.CORNER_RADIUS,
  ProductType.INSIDE_DIAGONAL,
  ProductType.DIAGONAL,
  ProductType.JOINT_POINT,
  ProductType.SINK,
  ProductType.SINK_LABOR,
  ProductType.CUTOUT,
  ProductType.LABOR,
  ProductType.TEAR_OUT,
  ProductType.COOKING_APPLIANCE,
  ProductType.FAUCET,
  ProductType.DISHWASHER,
  ProductType.REFRIGERATOR,
  ProductType.CUSTOM_WORK,
  ProductType.PLUMBING,
  ProductType.OTHER,
  ProductType.OVERSIZE_FEE,
  ProductType.MILEAGE_TIER,
  ProductType.ELECTRICAL_CUTOUT,
  ProductType.FAUCET_CUTOUT,
  ProductType.CHIP_MINIMIZER,
  ProductType.OPTIONAL_PRODUCT,
  ProductType.MODIFY_ON,
].reduce(
  (acc, item, index) => ({ ...acc, [item]: index }),
  {} as Record<ProductType, number>
);
